<template>
    <div class="projects-page-outer">
        <div id="projects-page" v-bind:class="{'is-blurred': isLoading}">
            <TheLiteModal/>
            <TheLiteNavbar/>
            <div id="configurator-group-lite">
                <div class="sidenav sidenav-lite" v-if="openSidebar">
                    <vue-custom-scrollbar class="lite-sidebar-upper">
                        <router-view name="sidebar"></router-view>
                    </vue-custom-scrollbar>
                    <div class="lite-sidebar-lower">
                        <router-view name="lowerBarRight" :version="'lite'"></router-view>
                    </div>
                </div>
                <div id="workspace-group">
                    <div :id="workspaceID">
                        <router-view name="workspace"></router-view>
                    </div>
                    <router-view name="lowerBarLight"></router-view>
                </div>
            </div>
        </div>
        <Spinner v-show="isLoading"/>
    </div>
</template>

<script>
    import TheLiteModal from "./Modal/TheLiteModal";
    import TheLiteNavbar from "./Navbar/TheLiteNavbar";
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import Spinner from "./Spinner";
    import TempCopyRight from "./TempCopyRight";

    export default {
        name: "LiteConfiguratorPage",
        components: {
            TempCopyRight,
            Spinner,
            TheLiteNavbar,
            TheLiteModal,
            vueCustomScrollbar
        },
        data() {
            return {
                sidebarExceptions: [
                    'liteProjects',
                    'liteSelectProjects',
                    'lightResultImages'
                ],
                // devicePixelRatio: 1,
                reloadingTimer: null
            }
        },
        created() {
            window.addEventListener("resize", this.devicePixelRatioReload);
            // this.devicePixelRatio = window.devicePixelRatio
        },
        computed: {
            isLoading() {
                return !!this.$store.getters["IN_PROGRESS"];
            },
            openSidebar() {
                let route = this.$store.state.route.name;
                return !this.sidebarExceptions.includes(route);
            },
            workspaceID() {
                if (this.openSidebar) {
                    return 'workspace-lite'
                } else {
                    return 'workspace-lite-wide'
                }
            }
        },
        destroyed() {
            window.removeEventListener("resize", this.devicePixelRatioReload);
        },
        methods: {
            devicePixelRatioReload() {
                if (this.reloadingTimer) {
                    clearTimeout(this.reloadingTimer);
                    this.reloadingTimer = null;
                }
                // if (window.devicePixelRatio !== this.devicePixelRatio) {
                //     this.devicePixelRatio = window.devicePixelRatio;
                    this.reloadingTimer = setTimeout(() => {
                        window.location.reload();
                    }, 700);
                // }
            }
        }
    }
</script>

<style scoped>
#configurator-group-lite {
    display: inline-flex;
    height: calc(100% - 82px);
    box-sizing: border-box;
}

</style>
